import {
  getData,
  postData,
  getFileData
} from './api-base.service'

export const getUniversitySignInList = (groupNumber, termId) => {
  let data = {
    groupNumber: groupNumber,
    termId: termId
  };
  var result = getData('/SignInManage/GetUniversitySignInList', data);
  return result;
}

export const getVocationalTrainingSignInList = (courseCategory, termId) => {
  let data = {
    courseCategory: courseCategory,
    termId: termId
  };
  var result = getData('/SignInManage/GetVocationalTrainingSignInList', data);
  return result;
}

export const getSignInManagementData = (termId, teacherId, courseId, campusId, getEmailVideo = true) => {
  if (typeof campusId == "undefined") {
    campusId = 0;
  }
  let data = {
    termId: termId,
    teacherId: teacherId,
    courseId: courseId,
    campusId: campusId,
    getEmailVideo: getEmailVideo
  };
  var result = getData('/SignInManage/GetSignInManagementData', data);
  return result;
}

export const saveStudentCourseAttendanceHistory = (termId, teacherId, courseId, campusId) => {
  if (typeof campusId == "undefined") {
    campusId = 0;
  }
  let data = {
    termId: termId,
    teacherId: teacherId,
    courseId: courseId,
    campusId: campusId
  };
  var result = getData('/SignInManage/SaveStudentCourseAttendanceHistory', data);
  return result;
}

export const saveStudentCourseAttendanceHistoryForAll = (termId, groupNumber) => {

  let data = {
    termId: termId,
    groupNumber: groupNumber,
  };
  var result = getData('/SignInManage/SaveStudentCourseAttendanceHistoryForAll', data);
  return result;
}


export const saveStudentSignIns = (studentId, data) => {
  return postData(`/SignInManage/SaveStudentSignIns?studentId=${studentId}`, data);
}

export const mergeWeekCourse = (courseActivationIdList, isMerge) => {
  let data = {
    CourseActivationIdList: courseActivationIdList,
    IsMerge: isMerge
  };
  var result = postData('/SignInManage/MergeCourse', data);
  return result;
}

export const saveCourseActivationCourseMinutes = (courseActivationId, minutes) => {
  let data = {
    courseActivationId: courseActivationId,
    minutes: minutes
  };
  var result = postData(`/SignInManage/SaveCourseActivationCourseMinutes?courseActivationId=${data.courseActivationId}&minutes=${data.minutes}`);
  return result;
}

export const saveCourseActivationCourseContent = (courseActivationId, content) => {
  let data = {
    courseActivationId: courseActivationId,
    content: content
  };
  var result = postData(`/SignInManage/SaveCourseActivationCourseContent?courseActivationId=${data.courseActivationId}&content=${data.content}`);
  return result;
}

export const saveCourseActivationVideoName = (courseActivationId, videoName) => {
  let data = {
    courseActivationId: courseActivationId,
    videoName: videoName
  };
  var result = postData(`/SignInManage/SaveCourseActivationVideoName?courseActivationId=${data.courseActivationId}&videoName=${data.videoName}`);
  return result;
}

export const saveCourseActivationCourseCategory = (courseActivationId, courseCategory) => {
  let data = {
    courseActivationId: courseActivationId,
    courseCategory: courseCategory
  };
  var result = postData(`/SignInManage/SaveCourseActivationCourseCategory?courseActivationId=${data.courseActivationId}&courseCategory=${data.courseCategory}`);
  return result;
}

export const saveCourseActivationHasSignIn = (courseActivationId, hasSignIn) => {
  let data = {
    courseActivationId: courseActivationId,
    hasSignIn: hasSignIn
  };
  return postData(`/SignInManage/SaveCourseActivationHasSignIn?courseActivationId=${data.courseActivationId}&hasSignIn=${data.hasSignIn}`);
}

export const saveCaTimestampStatus = (courseActivationId, value) => {
  return postData(`/SignInManage/SaveCaTimestampStatus?courseActivationId=${courseActivationId}&value=${value}`);
}

export const saveCaCameraStatus = (courseActivationId, value) => {
  return postData(`/SignInManage/SaveCaCameraStatus?courseActivationId=${courseActivationId}&value=${value}`);
}

export const saveCaSpeedupElementStatus = (courseActivationId, value) => {
  return postData(`/SignInManage/SaveCaSpeedupElementStatus?courseActivationId=${courseActivationId}&value=${value}`);
}

export const saveCaActualStartEndTime = (courseActivationId, startTime, endTime) => {
  let data = {
    CourseActivationId: courseActivationId,
    StartTime: startTime,
    EndTime: endTime
  };
  return postData('/SignInManage/SaveCaActualStartEndTime', data);
}

export const saveCaBreakStartEndTime = (courseActivationId, startTime, endTime) => {
  let data = {
    CourseActivationId: courseActivationId,
    StartTime: startTime,
    EndTime: endTime
  };
  return postData('/SignInManage/SaveCaBreakStartEndTime', data);
}

export const getTeacherCourseAttendanceInWeek = (termId, teacherId, courseId, campusId, week) => {
  let data = {
    termId: termId,
    teacherId: teacherId,
    courseId: courseId,
    campusId: campusId,
    week: week
  };
  var result = getData('/SignInManage/GetTeacherCourseAttendanceInWeek', data);
  return result;
}

export const getTeacherCourseAttendanceInWeeks = (termId, teacherId, courseId, campusId, courseActivationIdList) => {
  let data = {
    TermId: termId,
    TeacherId: teacherId,
    CourseId: courseId,
    CampusId: campusId,
    CourseActivationIdList: courseActivationIdList
  };
  var result = postData('/SignInManage/CalculateTeacherCourseAttendanceInWeeks', data);
  return result;
}

export const reassignSignIn = (courseId, teacherId, campusId, newCourseId, newTeacherId, newCampusId, studentList) => {
  let data = {
    CourseId: courseId,
    TeacherId: teacherId,
    CampusId: campusId,
    NewCourseId: newCourseId,
    NewTeacherId: newTeacherId,
    NewCampusId: newCampusId,
    StudentList: studentList
  };
  var result = postData('/SignInManage/ReassignSignIn', data);
  return result;
}

export const recoverReassignSignIn = (courseId, teacherId) => {
  let data = {
    courseId: courseId,
    teacherId: teacherId
  };
  return getData(`/SignInManage/RecoverReassignSignIn`, data);
}

export const getSignInQueryListByStudent = (courseType, termId, groupNumber = null, courseCategory = null, phone = null, isVideoCourseRemoved = false) => {
  let data = {
    courseType,
    termId,
    groupNumber,
    courseCategory,
    phone,
    isVideoCourseRemoved
  };

  var result = getData('/SignInManage/GetSignInQueryListByStudent', data);
  return result;
}

export const getSignInQueryListByCourse = (courseType, termId, courseId, week, searchDate, isVideoCourseRemoved = false, isYearCourseMerged = false, watchMintues = 100) => {
  let data = {
    courseType,
    termId,
    courseId,
    week,
    searchDate,
    isVideoCourseRemoved,
    isYearCourseMerged,
    watchMintues
  };

  var result = getData('/SignInManage/GetSignInQueryListByCourse', data);
  return result;
}

export const getSignInQueryListForTeacher = (courseType, groupNumber, termId, teacherId, isVideoCourseRemoved = false) => {
  let data = {
    courseType,
    groupNumber,
    termId,
    teacherId,
    isVideoCourseRemoved
  };

  var result = getData('/SignInManage/GetSignInQueryListForTeacher', data);
  return result;
}

export const getSignInQueryListForSupervisorPageData = (condition) => {
  let data = condition;
  return postData('/SignInManage/GetSignInQueryListForSupervisorPageData', data);
}

export const getStudentScoreCollectionPageData = (courseType, groupNumber, termId, teacherId, courseId, trainingCategoryId, campusId, week, searchDate, isVideoCourseRemoved = false, isYearCourseMerged = false) => {
  let data = {
    courseType,
    groupNumber,
    termId,
    teacherId,
    courseId,
    trainingCategoryId,
    campusId,
    week,
    searchDate,
    isVideoCourseRemoved,
    isYearCourseMerged
  };

  var result = getData('/SignInManage/GetStudentScoreCollectionPageData', data);
  return result;
}

export const exportSignInQueryListByStudent = (courseType, termId, groupNumber = null, courseCategory = null, phone = null, isVideoCourseRemoved = false) => {
  let data = {
    courseType,
    termId,
    groupNumber,
    courseCategory,
    phone,
    isVideoCourseRemoved
  };

  var result = getFileData('/SignInManage/ExportSignInQueryListByStudent', data, true, true);
  return result;
}

export const exportSignInQueryListByCourse = (courseType, termId, courseId, groupNumber = null, courseCategory = null, campusId = null, week = null, searchDate = null, isVideoCourseRemoved = false, isYearCourseMerged = false, watchMintues = 100) => {
  let data = {
    courseType,
    termId,
    courseId,
    groupNumber,
    courseCategory,
    campusId,
    week,
    searchDate,
    isVideoCourseRemoved,
    isYearCourseMerged,
    watchMintues
  };

  var result = getFileData('/SignInManage/ExportSignInQueryListByCourse', data, true, true);
  return result;
}

export const exportSignInQueryListByTeacher = (courseType, termId, groupNumber = null, courseCategory = null, teacherId = null, isVideoCourseRemoved = false) => {
  let data = {
    courseType,
    termId,
    groupNumber,
    courseCategory,
    teacherId,
    isVideoCourseRemoved
  };

  var result = getFileData('/SignInManage/ExportSignInQueryListByTeacher', data, true, true);
  return result;
}

export const exportSignInQueryListForSupervisor = (condition) => {
  let data = condition;

  return getFileData('/SignInManage/ExportSignInQueryListForSupervisor', data, false, true);
}

export const exportStudentScore = (courseType, groupNumber, termId, teacherId, courseId, trainingCategoryId, campusId) => {
  let data = {
    courseType,
    groupNumber,
    termId,
    teacherId,
    courseId,
    trainingCategoryId,
    campusId
  };

  var result = getFileData('/SignInManage/ExportStudentScore', data, true, true);
  return result;
}

export const downloadStudentScoreAttachments = (courseType, groupNumber, termId, teacherId, courseId, trainingCategoryId, campusId) => {
  let data = {
    courseType,
    groupNumber,
    termId,
    teacherId,
    courseId,
    trainingCategoryId,
    campusId
  };

  var result = getFileData('/SignInManage/DownloadStudentScoreAttachments', data, true, true);
  return result;
}

export const saveCourseActivationDetail = (courseActivationId, actualStartTime, actualEndTime,breakStartTime,breakEndTime,
  content, courseCategory, hasSignIn, timestampStatus, cameraStatus, speedupElementStatus, isFreeVideo) => {
  let data = {
    courseActivationId: courseActivationId,
    ActualStartTime: actualStartTime,
    ActualEndTime: actualEndTime,
    BreakStartTime: breakStartTime,
    BreakEndTime: breakEndTime,
    Content: content,
    CourseCategory: courseCategory,
    HasSignIn: hasSignIn,
    TimestampStatus: timestampStatus,
    CameraStatus: cameraStatus,
    SpeedupElementStatus: speedupElementStatus,
    IsFreeVideo: isFreeVideo
  };
  return postData(`/SignInManage/SaveCourseActivationDetail`, data);
}

export const getUniversityScoreLocks = (termId) => {
  return getData('/SignInManage/GetUniversityScoreLocks', {termId: termId});
}

export const saveUniversityScoreLocks = (termId, list) => {
  return postData(`/SignInManage/SaveUniversityScoreLocks?termId=${termId}`, list);
}

export const cancelCourseActivation = (courseActivationId, reason) => {
  return postData("/SignInManage/CancelCourseActivation", {
    CourseActivationId: courseActivationId,
    Reason: reason
  });
}


// WEBPACK FOOTER //
// ./src/service/signInManage.service.js